import CommonImage from "@/components/common/image/CommonImage";
import { Drawer } from "antd";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Image from "next/image";
import React from "react";
import { useSelector } from "react-redux";

export default function AuthMenuDrawer({
  isMenuOpen,
  setIsMenuOpen,
  userInfo,
}) {
  const pathname = usePathname();
  const setting = useSelector((state) => state.setting.data);
  const menu = [
    {
      icon: "/images/student-dashboard/dashboard.avif",
      label: "ড্যাশবোর্ড",
      selected: true,
      link: "/student/dashboard",
    },
   
    {
      icon: "/images/student-dashboard/online-course.avif",
      label: "আমার কোর্স",
      link: "/student/my-courses",
    },
    {
      icon: "/images/student-dashboard/calender.avif",
      label: "ক্লাস ক্যালেন্ডার",
      link: "/student/calender",
    },
    {
      icon: "/images/student-dashboard/faq.avif",
      label: "Q&A (চ্যাট বেসড)",
      link: "/student/inbox",
    },
    {
      icon: "/images/student-dashboard/ranking.avif",
      label: "লিডারবোর্ড",
      link: "/student/leaderboard",
    },
    {
      icon: "/images/student-dashboard/result.avif",
      label: "রেজাল্ট",
      link: "/student/result",
    },
    {
      icon: "/images/student-dashboard/payment-history.avif",
      label: "পেমেন্ট হিস্টোরি ও ইনভয়েস ডাউনলোড",
      link: "/student/payment-history",
    },
     {
      icon: "/images/student-dashboard/profile.avif",
      label: "প্রোফাইল",
      link: "/student/profile",
    },
    {
      icon: "/images/student-dashboard/password-change.avif",
      label: "পাসওয়ার্ড পরিবর্তন",
      link: "/student/password-change",
    },
  ];

  return (
    <Drawer
      open={isMenuOpen}
      onClose={() => setIsMenuOpen(false)}
      placement="right"
      height="auto"
      maskClosable
      destroyOnClose
      styles={{
        header: { display: "none" },
      }}
      closable={false}
      className="mobile-sidebar"
    >
      {/* Drawer Header */}
      <div className="bar-header">
        <a herf="#" className="img-wrap leading-0">
          <CommonImage
            src={
                setting?.logo_light_url ??
                "/images/header-footer/main_logo_light.avif"
              }
            alt="Icon"
            className="icon-img [.dark_&]:hidden inline-block" 
          />
          <CommonImage
            src={
                setting?.logo_dark_url ??
                "/images/header-footer/main_logo_light.avif"
              }
            alt="Icon"
            className="icon-img hidden [.dark_&]:inline-block" 
          />
        </a>
        <button onClick={() => setIsMenuOpen(false)} className="close-icon">
          ✕
        </button>
      </div>

      {/* Drawer Content */}
      <div className="sidebar-content">
        {/* profile-part */}
        <div className="profile-part-wrap">
          <div className="student-header-wrap bg-pattern">
            <div className="student-image-wrap">
              <Image
                src={
                  userInfo?.student?.profile_url ??
                  "/images/student-dashboard/student-profile.avif"
                }
                className="student-image"
                alt={"Profile"}
                width={250}
                height={250}
              />
            </div>
            <div className="Student-identity ">
              <h2 className="name">{userInfo?.name}</h2>
              <div className="identy-data">
                <p className="data">
                  <span className="text-width">ক্লাসঃ</span>{" "}
                  {userInfo?.student?.class?.title}
                </p>
                <p className="data">
                  <span className="text-width">বিভাগঃ</span>{" "}
                  {userInfo?.student?.group?.name}
                </p>
                <p className="data">
                  <span className="text-width">পরীক্ষাঃ</span> এস এস সি
                </p>
              </div>
            </div>
          </div>
          {/* List */}
          <div className="flex flex-col gap-6">
            <div className="student-dashboard-list">
              {menu.map((item, i) => {
                const isActive = pathname === item.link;
                return (
                  <Link
                    key={i}
                    href={item.link}
                    className={`list-item ${isActive ? "selected" : ""}`}
                    onClick={()=>setIsMenuOpen(false)}
                  >
                    <CommonImage
                      src={item.icon}
                      className="student-image"
                      alt="Profile"
                    />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
